import { useSearchParameter } from '@xing-com/crate-hooks-use-search-parameter';
import { SEARCH_STATE_PARAMS } from '@xing-com/crate-jobs-constants';
import { useSearchState } from '@xing-com/crate-jobs-hooks';
import { DeleteTag } from '@xing-com/tag';

import { SINCE_PERIOD_OPTIONS } from '../../../../helpers';

export const TimeFrameTag: React.FC = () => {
  const { sincePeriod } = useSearchState();
  const { deleteSearchParameter } = useSearchParameter();

  const handleOnClick = (): void => {
    deleteSearchParameter(SEARCH_STATE_PARAMS.sincePeriod, { replace: false });
  };

  return sincePeriod ? (
    <DeleteTag onClick={handleOnClick} onDelete={handleOnClick} selected>
      {SINCE_PERIOD_OPTIONS[sincePeriod]}
    </DeleteTag>
  ) : null;
};
